import axios from "axios";
import { getStorage, clearStorage } from "../../helper/storage";
import { methodType } from "./apiEndPoints";
import config from "./apiConfig";

const API_BASE_URL =
 'https://api.electioneasy.in/api/'||
  (process.env.NODE_ENV === "development" ? "/api/" : config.baseURL);

axios.interceptors.response.use(
  (response) => {
    const { data } = response;
    return data;
  },
  (error) => {
    const { response } = error;
    const data = response?.data;
    const exclude = "auth/login";
    if (response?.status === 401 && !response.config?.url.includes(exclude)) {
      clearStorage();
      return Promise.reject(error);
    }
    if (data) {
      return data;
    } else {
      return Promise.reject(error);
    }
  }
);

// export const performRequest = async (
//   method,
//   url,
//   data = {},
//   isLoggedin = true,
//   formData = false,
//   isBlob = false
// ) => {
//   url = url.replaceAll("#", "%23");
//   const config = {
//     method,
//     url,
//     baseURL: "https://api.electioneasy.in/api/",
//   };
//   if (isBlob) {
//     config["responseType"] = "blob";
//   }

//   if (
//     method === methodType.PUT ||
//     method === methodType.PATCH ||
//     method === methodType.POST ||
//     method === methodType.DELETE
//   ) {
//     config.data = data;
//   }

//   if (method === methodType.GET) {
//     config.params = data;
//   }

//   if (formData) {
//     config.headers = {
//       "Content-Type": "multipart/form-data",
//     };
//   } else {
//     config.headers = {
//       "Content-Type": "application/json; charset=utf-8",
//     };
//   }

//   if (isLoggedin) {
//     let { access_token } = getStorage("logged-in") || null;
//     config.headers.Authorization = `Bearer ${access_token}`;
//   }
//   return axios.request(config);
// };

export const performRequest = async (
  method,
  url,
  data = {},
  isLoggedin = true,
  formData = false,
  isBlob = false,
  // Extra axios options, e.g. { onUploadProgress } for file uploads.
  extraConfig = {}
) => {
  url = url.replaceAll("#", "%23");
  const config = {
    method,
    url,
    baseURL: API_BASE_URL,
    ...extraConfig,
  };

  if (isBlob) {
    config["responseType"] = "blob";
  }

  if (
    [
      methodType.PUT,
      methodType.PATCH,
      methodType.POST,
      methodType.DELETE,
    ].includes(method)
  ) {
    config.data = data;
  }
console.log("PATCH BODY", config.data);
  if (method === methodType.GET) {
    config.params = data;
  }
console.log("Axios Config:", config);
  if (formData) {
    // Do not set Content-Type manually; let Axios handle it
    delete config.headers?.["Content-Type"];
  } else {
    config.headers = {
      "Content-Type": "application/json; charset=utf-8",
    };
  }

  if (isLoggedin) {
    const { access_token } = getStorage("logged-in") || {};
    if (access_token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${access_token}`,
      };
    }
  }

  return axios.request(config);
};

export const performRequestKaran = async (
  method,
  url,
  data = {},
  isLoggedin = true,
  formData = false,
  isBlob = false
) => {
  url = url.replaceAll("#", "%23");
  const config = {
    method,
    url,
    baseURL: "https://www.karan-oms.com/",
  };
  if (isBlob) {
    config["responseType"] = "blob";
  }

  if (
    method === methodType.PUT ||
    method === methodType.PATCH ||
    method === methodType.POST ||
    method === methodType.DELETE
  ) {
    config.data = data;
  }

  if (method === methodType.GET) {
    config.params = data;
  }
  console.log(method, methodType.POST);
  if (formData) {
    config.headers = {
      "Content-Type": "multipart/form-data",
    };
    config.headers["Access-Control-Allow-Origin"] = "*";
  } else {
    config.headers = {
      "Content-Type": "*",

      // "Content-Type": "application/json; charset=utf-8",
    };
    config.headers["Access-Control-Allow-Origin"] = "*";
  }

  // if (isLoggedin) {
  //   let { access } = getStorage("logged-in") || null;
  //   config.headers.Authorization = `Bearer ${access}`;
  // }
  return axios.request(config);
};
